import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import classNames from 'classnames/bind';
import { Player } from 'video-react';

import BackButton from '../BackButton/BackButton';
import { HorizontalScroller } from '../HorizontalScroller/HorizontalScroller';

import globalStyles from '../../global.module.css';
import styles from './FlightPage.module.css';
import FlightMap from '../FlightMap/FlightMap';

import tripData2 from '../../tripData2'; // short haul
import tripData3 from '../../tripData3'; // long haul

import sydneyVid from './video/sydney.mov';
import sydneyPoster from './video/sydney-poster.jpg';
import AirlineLogo from '../AirlineLogo/AirlineLogo';

import loungeVideo from './video/muir_lounge.mov';

const cx = classNames.bind(styles);
const cxGlobal = classNames.bind(globalStyles);


class FlightPage extends Component {
  constructor(props) {
    super(props);

    let airline = this.props.flightData.airline.toLowerCase().split(' ').join('');
    this.state = {
      selectedTime: 1,
      selectedAirline: airline,
    };

    this.timeSelected = this.timeSelected.bind(this);
  }


  getTimeButtonClasses(id) {
    return cx({
      flight: true,
      selected: parseInt(this.state.selectedTime, 10) === parseInt(id, 10),
    });
  }

  getTimeButtonStyle(id, activeColor) {
    return (parseInt(this.state.selectedTime, 10) === parseInt(id, 10)) ? {
      borderColor: activeColor,
    } : null;
  }

  timeSelected(e) {
    const selectedTime = e.currentTarget.getAttribute('data-id')
    if (parseInt(selectedTime, 10) === parseInt(this.state.selectedTime, 10)) {
      return this.setState({ selectedTime:undefined });
    }
    this.setState({ selectedTime });
  }

  render() {
    const { direction } = this.props.match.params;
    const { isLongHaul } = this.props;
    const isOutbound = direction === 'outbound';
    const activeTripData = this.props.isLongHaul ? tripData3 : tripData2;

    const activeVideo = sydneyVid
    const activePoster = sydneyPoster

    const airlineClassName = globalStyles[this.state.selectedAirline];
    const getPlaneType = () => {
      if (isLongHaul) {
        return 'boeing';
      }
      if (isOutbound) {
        return 'pilatus';
      }
      return 'enbraer';
    };
    const footerStyles = cxGlobal({
      [globalStyles.return]: direction === 'return',
      [globalStyles.flightsFooter]: true,
      [airlineClassName]: this.state.selectedAirline,
    });

    const footerButtonStyles = cxGlobal({
      button: true,
      disabled: !this.state.selectedTime,
    });

    let activeColor = '#1F1F1F'; // default
    let activeAirline = 'united'; // default
    if (isLongHaul) {
      activeAirline = isOutbound ? 'virgin' : 'united';
      activeColor = isOutbound ? '#9D1649' : '#153875'; // virgin red : united blue
    } else {
      activeColor = isOutbound ? '#17375B' : '#1F1F1F'; // surfair blue : jetsuite black
      activeAirline = isOutbound ? 'surfair' : 'jetsuite';
    }

    let flightData; 

    if(isLongHaul) {
      flightData = isOutbound ? 
      {
        from: "San Francisco",
        to: "Santa Barbara",
        airline: "SurfAir",
        departureTime: moment('7:15pm'),
        aircraft: "Pilatus PC-12"
      } :
      {
        from: "Santa Barbara",
        to: "San Francisco",
        airline: "Jet Suite X",
        departureTime: moment('5:15pm'),
        aircraft: "Pilatus PC-12"
      }
    } else {
      flightData = isOutbound ? 
      {
        from: "San Francisco",
        to: "Santa Barbara",
        airline: "SurfAir",
        departureTime: moment('5:15pm'),
        aircraft: "Pilatus PC-12"
      } :
      {
        from: "SantaBarbara",
        to: "San Francisco",
        airline: "Jet Suite X",
        departureTime: moment('5:15pm'),
        aircraft: "Pilatus PC-12"
      }
    }

    return (
      <div className={[styles.flightPage, ( this.props.isLongHaul ? styles.isLongHaul : styles.isShortHaul)].join(' ')}>
        <div className={[styles.header, (direction==='return' ? styles.return : '')].join(' ')}>
          <BackButton className={styles.back} />
          { direction === 'outbound' ?
            <FlightMap
              styleID="b3nroth/cjj6yeo2x03jm2rto9w04stui"
              routeData={activeTripData[0]}
              lineColor="#2764A9"
            />
            : <FlightMap
              styleID="b3nroth/cjj6yeo2x03jm2rto9w04stui"
              routeData={activeTripData[1]}
              lineColor="#153875"
            />
          }
        </div>

        <div className={styles.flightInfo}>
          <small>{`${isOutbound ? 'OUTBOUND' : 'RETURN'} FLIGHT`}</small>
          { direction === 'outbound' && this.props.startDate && this.props.endDate ?
            <h2>{this.props.startDate.format('dddd MMMM Do')}</h2> :
            <h2>{this.props.endDate.format('dddd MMMM Do')}</h2>
          }
          <ul className={globalStyles.details}>

            { isLongHaul ?
              <li>{isOutbound ? 'SFO → SYD' : 'SFO → OAK'}</li>
              : <li>{isOutbound ? 'SFO → SBA' : 'SBA → SFO'}</li>
            }
            <li>1h 10min</li>
          </ul>
        </div>

        <div className={styles.flights}>
          <HorizontalScroller>
            <div onClick={this.timeSelected} data-id="1" className={this.getTimeButtonClasses(1)} style={this.getTimeButtonStyle(1, activeColor)}>
              <div>
                <h4>{isOutbound ? '7:15 AM' : '5:15 PM'}</h4>
                <span>{isOutbound ? 15 : 22} Seats</span>
              </div>
            </div>
            {/* <div onClick={this.timeSelected} data-id="2" className={this.getTimeButtonClasses(2)} style={this.getTimeButtonStyle(2, activeColor)}>
              <div>
                <h4>10:25 AM</h4>
                <span>7 Seats</span>
              </div>
            </div>
            <div onClick={this.timeSelected} data-id="3" className={this.getTimeButtonClasses(3)} style={this.getTimeButtonStyle(3, activeColor)}>
              <div>
                <h4>5:15 PM</h4>
                <span>3 Seats</span>
              </div>
            </div>
            <div onClick={this.timeSelected} data-id="4" className={this.getTimeButtonClasses(4)} style={this.getTimeButtonStyle(4, activeColor)}>
              <div>
                <h4>6:45 PM</h4>
                <span>6 Seats</span>
              </div>
            </div>
            <div onClick={this.timeSelected} data-id="5" className={this.getTimeButtonClasses(5)} style={this.getTimeButtonStyle(5, activeColor)}>
              <div>
                <h4>10:05 PM</h4>
                <span>2 Seats</span>
              </div>
            </div>
            <div onClick={this.timeSelected} data-id="6" className={this.getTimeButtonClasses(6)} style={this.getTimeButtonStyle(6, activeColor)}>
              <div>
                <h4>4:05 AM</h4>
                <span>10 Seats</span>
              </div>
            </div> */}
          </HorizontalScroller>
        </div>

        <div className={styles.flightDetails}>
          <h2>Flight Details</h2>
          <h3>Included Amenities</h3>
          <div className={styles.flightDetailsLinks}>

            <Link to={'#'}>
              <img src={require(isOutbound ? './img/amenity-meals.jpg' : './img/amenity-meals2.jpg')} alt="" />
              <h4>3 Meals</h4>
            </Link>
            <Link to={'#'}>
              <img src={require(isOutbound ? './img/amenity-ent.jpg' : './img/amenity-ent2.jpg')} alt="" />
              <h4>In-flight entertainment</h4>
            </Link>
            { this.props.isLongHaul ?
              <Link to={'#'}>
                <img src={require(isOutbound ? './img/amenity-wifi.jpg' : './img/amenity-wifi2.jpg')} alt="" />
                <h4>Complimentary WiFi</h4>
              </Link>
            : null }
            { this.props.isLongHaul ?
              <Link to={'#'}>
                <img src={require(isOutbound ? './img/amenity-headphone.jpg' : './img/amenity-headphone2.jpg')} alt="" />
                <h4>Noise-Cancelling Headphones</h4>
              </Link>
            : null }
          </div>
          {/* <a className={styles.more} >View more</a> */}
        </div>

        {isLongHaul ?
          <div className={styles.availableCabins}>
            <h2>Available Cabins</h2>
            <HorizontalScroller>
              <div className={styles.cabin}>
                <img src={require('./img/cabins-economy.png')} alt="" />
                <h3>Economy</h3>
                <span>roundtrip $1285</span>
                <span>30 seats available</span>
              </div>
              <div className={styles.cabin}>
                <img src={require('./img/cabins-prem-economy.png')} alt="" />
                <h3>Premium Economy</h3>
                <span>+$500 one way</span>
                <span>15 seats available</span>
              </div>
              <div className={styles.cabin}>
                <img src={require('./img/cabins-business.png')} alt="" />
                <h3>Business</h3>
                <span>+$1,000 one way</span>
                <span>9 seats available</span>
              </div>
            </HorizontalScroller>
            <Link to={`/flights/review`}>View Seats</Link>
          </div>
        : null }

        {isLongHaul && isOutbound ?
          <div>
            <div className={[styles.smartTag, styles.longHaulModule].join(' ')}>
              <h2>Peace of mind for your checked bags.</h2>
              <p>Get your SmartTag and track your bags from curb to carousel, exclusively for Airbnb Above members.</p>
            </div>

            <div className={[styles.handleDetails, styles.longHaulModule].join(' ')}>
              <h2>We’ll hand the details of your trip. </h2>
              <p>Airbnb Above members with complete profiles will be able to sign up for automatic tourist visa approvals.</p>
            </div>
          </div>
        : null }

        {!isLongHaul && isOutbound ?
          <div className={styles.comparison}>
            <h2>The fastest way to get there.</h2>
            <p>Live with no lines - arrive just 15 minutes before your flight and take off.</p>

            <div className={styles.compare}>
              <img src={require('./img/comparison-surfair.png')} alt="" width="121px" />
              <p><strong>Surfair flight:</strong> 1h 10min Total</p>
            </div>

            <div className={styles.compare}>
              <img src={require('./img/comparison-commercial.png')} alt="" width="279px" />
              <p><strong>Commercial flights:</strong> ~2h 30min total</p>
            </div>

            <div className={styles.videoPlayer}>
              <div className={styles.comparisonVideo}>
                <Player
                  playsInline
                  fluid={true}
                  autoPlay
                  loop
                  width={window.width}
                  muted={true}
                  poster={activePoster}
                  src={activeVideo}
                />
              </div>
            </div>
          </div>
        : null }

        <div className={styles.meetYourCrew} style={{backgroundColor: (activeColor)}}>
          <AirlineLogo airline={activeAirline} style={{ width: '194px' }} />
          <p>
            {isLongHaul ?
              isOutbound ?
                'Part of the world-renowned Virgin Group and a leader among leisure airlines.'
                : 'Fly the friendly skies with United, a Star Alliance airline with global reach.'
              
              : isOutbound ?
                'Unlimited flights made simple, efficient and effortless.'
                : 'Semi-Private Flying, Not-So-Private Fares.'
            }

          </p>
          <h2>Meet your crew</h2>
          <HorizontalScroller>
            <div className={styles.crewMember}>
              <img src={require('./img/crew-marie.png')} alt="" />
              <h3>Marie Hirsch</h3>
              <span>pilot</span>
            </div>
            <div className={styles.crewMember}>
              <img src={require('./img/crew-polly.png')} alt="" />
              <h3>Polly Jones</h3>
              <span>copilot</span>
            </div>
            <div className={styles.crewMember}>
              <img src={require('./img/crew-steve.png')} alt="" />
              <h3>Steve Uch</h3>
              <span>flight attendant</span>
            </div>
            <div className={styles.crewMember}>
              <img src={require('./img/crew-marie.png')} alt="" />
              <h3>Marie Hirsch</h3>
              <span>pilot</span>
            </div>
          </HorizontalScroller>
        </div>

        <div className={[styles.lounges, (isOutbound ? styles.outbound : null) ,styles.longHaulModule].join(' ')}>
          <div className={styles.loungeWrapper}>
            <img src={require('./img/airbnb-icon.png')} alt="" width="22px" />
            <h2>{isOutbound ? 'Muir Lounge' : 'Taronga Lounge'}</h2>
            <p>Airbnb has reinvented what airport<br /> lounges can be, and Airbnb Above<br /> members have exclusive access.</p>
            {isOutbound ? <Player
                  className={styles.loungePlayer}
                  playsInline
                  fluid={true}
                  autoPlay
                  loop
                  width={window.width}
                  muted={true}
                  // poster={activePoster}
                  src={loungeVideo}
                /> : null}
          </div>
        </div>

        <div className={[styles.planeDetail, styles[getPlaneType()]].join(' ')}>
          {isLongHaul ?
            <h2>Boeing 777</h2>
          : <h2>
            { isOutbound ?
              'Pilatus PC12'
              : 'Embraer 135'
            }
            </h2>
          }
          {isLongHaul ?
            <p>The Boeing 777, boasts a unique combination of superior range, style, outstanding fuel efficiency, and preferred comfort.</p>
          : <p>
            { isOutbound ?
              'Comfort, power, and safety. Swiss engineering trusted worldwide.'
              : 'Luxuriously reconfigured for your personal needs'
            }
            </p>
          }
          {isLongHaul ?
            <div className={styles.availableSeats} style={{borderColor: activeColor}}>
              <img src={require('./img/seats-icon.png')} alt="" width="25px" />
              <h3 style={{color: activeColor }}>GREAT SEATS AVAILABLE!</h3>
              <p>{`This Boeing 777 for your selected flight to Sydney is only ${isOutbound ? '30%' : '40%'} full right now.`}</p>
            </div>
          : 
            (!isOutbound ?
              <div className={styles.availableSeats} style={{borderColor: activeColor}}>
                <img src={require('./img/seats-icon.png')} alt="" width="25px" />
                <h3 style={{color: activeColor }}>NEW INTERIOR</h3>
                <p>This airplane has power plugs for both window and aisle seats.</p>
              </div>
            : null)
          }
        </div>

        <div className={[styles.airportDetails, styles.longHaulModule].join(' ')} style={isLongHaul ? {backgroundImage:`url(${require(`./img/airports/airport_${activeAirline}.jpg`)}`} : null}>
          <h2>Airport</h2>
          <h3 style={{ color: activeColor }}>
            <span>{isOutbound ? 'SFO' : 'SYD'}</span><br />
            {isOutbound ? 'International A' : 'International B'}
          </h3>
          <p>
            { isOutbound ?
              'Everything you need to go from check-in to lift off in 40,000 square feet. SFO International Terminal A has wolrd class amenities for all.'
              : 'An international hub closer to the center of it all than you would imagine. Enjoy views of the bay and extensive duty free shopping.'
            }
          </p>

          <Link style={{ color: activeColor }} to={'#'}>View map</Link>
        </div>

        { !isLongHaul ?
          <div>
            <div className={styles.utility}>
              <div>
                <h2>Free parking</h2>
                <p>Get there faster with complimentary parking outside our terminal.</p>
              </div>
              <div>
                <img src={require('./img/parking.png')} alt="" width="95px" />
              </div>
            </div>

            <div className={[styles.utility, styles.noRightPadding].join(' ')}>
              <div>
                <h2>Tight schedule?</h2>
                <p>We can transport your checked bags straight to your home free of charge.</p>
                <Link to={`#`}>Learn more</Link>
              </div>
              <div>
                <img src={require('./img/tightSchedule.png')} alt="" width="126px" />
              </div>
            </div>
          </div>
          : null }

        <div className={footerStyles} style={{backgroundColor: activeColor}}>
          <div className={globalStyles.price}>
            <span>roundtrip</span> $280
            {/* <div className={globalStyles.airlineLogo}></div> */}
            <AirlineLogo airline={activeAirline} />
          </div>
          <Link
            className={ footerButtonStyles}
            style={{color: activeColor}}
            to={(direction === 'outbound' ? '/flights/return' : '/flights/review')}
            onClick={
              direction === 'outbound' ?
                () => this.props.setOutboundFlightData(flightData)
                : () => this.props.setReturnFlightData(flightData)
            }
          >
            Select flight
          </Link>
        </div>

      </div>
    );
  }
}

FlightPage.propTypes = {
  flightData: propTypes.shape(),
};

FlightPage.defaultProps = {
  flightData: {
    from: "San Francisco",
    to: "Santa Barbara",
    airline: "SurfAir",
    departureTime: moment('5:15pm'),
    aircraft: "Pilatus PC-12"
  },
};


const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  outboundFlightData: main.outboundFlightData,
  returnFlightData: main.returnFlightData,
  startDate: main.startDate || moment().day(5 + 7),
  endDate: main.endDate || moment().day(5 + 7),
});

const mapDispatchToProps = (dispatch) => {
  return {
    setOutboundFlightData: data =>
      dispatch({
        type: 'SET_OUTBOUND_FLIGHT_DATA',
        payload: data,
      }),
    setReturnFlightData: data =>
      dispatch({
        type: 'SET_RETURN_FLIGHT_DATA',
        payload: data,
      }),
    loadRouteData: data =>
      dispatch({
        type: 'LOAD_DATA',
        payload: data,
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FlightPage);



// WEBPACK FOOTER //
// ./src/components/FlightPage/FlightPage.jsx